const pad = (value) => String(value).padStart(2, '0')

const getCalendarParts = (value) => {
  if (value === null || value === undefined || value === '') return null

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null
    return { year: value.getFullYear(), month: value.getMonth() + 1, day: value.getDate() }
  }

  const raw = String(value).trim()
  const isoMatch = raw.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:T|\s|$)/)
  if (isoMatch) {
    return { year: Number(isoMatch[1]), month: Number(isoMatch[2]), day: Number(isoMatch[3]) }
  }

  const usMatch = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:T|\s|$)/)
  if (usMatch) {
    return { year: Number(usMatch[3]), month: Number(usMatch[1]), day: Number(usMatch[2]) }
  }

  return null
}

const isValidCalendarParts = ({ year, month, day } = {}) => {
  const date = new Date(year, month - 1, day)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

export const toLeaveCalendarKey = (value) => {
  const parts = getCalendarParts(value)
  if (!parts || !isValidCalendarParts(parts)) return ''
  return `${parts.year}-${pad(parts.month)}-${pad(parts.day)}`
}

export const formatLeaveCalendarDate = (value) => {
  const key = toLeaveCalendarKey(value)
  if (!key) return ''
  const [year, month, day] = key.split('-')
  return `${month}/${day}/${year}`
}

export const parseLeaveCalendarDate = (value) => {
  const key = toLeaveCalendarKey(value)
  if (!key) return null
  const [year, month, day] = key.split('-').map(Number)
  return new Date(year, month - 1, day)
}
